export default "__VITE_ASSET__CqMkf8GZ__"